import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WarrantyCustomerPortalService } from '@wsphere/customer-portal/web';
import { Warranty } from '@wsphere/warranties/domain';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({ changeDetection: ChangeDetectionStrategy.Eager, templateUrl: './warranty.page.html', standalone: false })
export class WarrantyPage implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    private warrantySvc: WarrantyCustomerPortalService
  ) {}

  private readonly warrantySubject = new BehaviorSubject<Warranty.Model | null>(null);
  readonly warranty$ = this.warrantySubject.pipe(filter((w): w is Warranty.Model => !!w));

  private subscription?: Subscription;

  ngOnInit() {
    this.subscription = (this.route.parent?.data ?? this.route.data)
      .pipe(map(data => data['warranty'] as Warranty.Model))
      .subscribe(warranty => this.warrantySubject.next(warranty));
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  /**
   * AC 4.4: after a successful renewal the card must reflect the new expiry/contract/coverages
   * immediately, without a manual reload. The contract number changes as part of renewal, so the
   * refetch uses the *new* contract number from the renewal result rather than stale local state.
   */
  async onRenewed(result: Warranty.RenewalResult) {
    const refreshed = await this.warrantySvc.getOneByContractNumber(result.contractNumber);
    if (refreshed) this.warrantySubject.next(refreshed);
  }
}
